var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonitor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1818 0H1.81818C1.33597 0 0.873508 0.210714 0.532533 0.585786C0.191558 0.960859 0 1.46957 0 2V30C0 30.5304 0.191558 31.0391 0.532533 31.4142C0.873508 31.7893 1.33597 32 1.81818 32H18.1818V36H12.7273C12.2451 36 11.7826 36.2107 11.4416 36.5858C11.1006 36.9609 10.9091 37.4696 10.9091 38C10.9091 38.5304 11.1006 39.0391 11.4416 39.4142C11.7826 39.7893 12.2451 40 12.7273 40H27.2727C27.7549 40 28.2174 39.7893 28.5584 39.4142C28.8994 39.0391 29.0909 38.5304 29.0909 38C29.0909 37.4696 28.8994 36.9609 28.5584 36.5858C28.2174 36.2107 27.7549 36 27.2727 36H21.8182V32H38.1818C38.664 32 39.1265 31.7893 39.4675 31.4142C39.8084 31.0391 40 30.5304 40 30V2C40 1.46957 39.8084 0.960859 39.4675 0.585786C39.1265 0.210714 38.664 0 38.1818 0ZM36.3636 28H3.63636V4H36.3636V28Z",
    fill: "#28ADE0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.b055ae03835430b59f408ca669293f37.svg";
export { ForwardRef as ReactComponent };